module.exports = __webpack_public_path__ + "static/media/7.4d4ec9eb.png";